import DigitalOrderConfig from 'umg-ember-backend/components/record-explorer/for/digital-order-config';

<template>
  <DigitalOrderConfig @records={{@model}} @recordType='digital-order-config' />
</template>
